import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  Customer, 
  CustomerProfile,
  CustomerCreateRequest, 
  CustomerUpdateRequest, 
  CustomerResponse,
  CustomerDataForAPI,
  CompleteCustomerData
} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  private _controller = 'inventory';
  private _customerController = 'customer';
  private _commonCustomerController = "common-customer";

  constructor(private _http: HttpClient) { }


  /**
   * Get all customers with pagination
   * @param page - Page number (0-based)
   * @param size - Page size
   * @param sort - Sort field
   * @param direction - Sort direction
   * @returns Observable with paginated customers response
   */
  getCustomers(search:string, page: number = 0, size: number = 20, sort: string = 'id', direction: string = 'DESC'): Observable<any> {
    const params = new HttpParams()
      .set('search', search)
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', `${sort},${direction}`);
    
    return this._http.get<any>(`${this._commonCustomerController}`, { params });
  }

  /**
   * Get customer by ID
   * @param id - Customer ID
   * @returns Observable with customer data
   */
  getCustomerById(id: number): Observable<any> {
    return this._http.get<any>(`customer/${id}`);
  }

  /**
   * Create customer with comprehensive data (regions, sites, users)
   * @param customerData - Complete customer data
   * @returns Observable with created customer response
   */
  createCustomerComplete(customerData: CustomerCreateRequest): Observable<CustomerResponse> {
    return this._http.post<CustomerResponse>(`${this._commonCustomerController}/onboard`, customerData);
  }

  /**
   * Get complete customer data with all relationships
   * @param id - Customer ID
   * @returns Observable with complete customer data
   */
  getCompleteCustomerData(id: number): Observable<CompleteCustomerData> {
    return this._http.get<CompleteCustomerData>(`${this._commonCustomerController}/${id}`);
  }

  /**
   * Update customer basic information
   * @param id - Customer ID
   * @param customerData - Customer data to update
   * @returns Observable with updated customer
   */
  updateCustomer(id: number, customerData: CustomerUpdateRequest): Observable<Customer> {
    return this._http.put<Customer>(`${this._commonCustomerController}/${id}`, customerData);
  }

}
